import { Link } from "react-router-dom";
import { ArrowLeft, XCircle } from "lucide-react";
import LogoMark from "@/components/LogoMark";

export default function PaymentCancel() {
  return (
    <div className="flex min-h-screen items-center justify-center bg-forest px-6">
      <div
        data-testid="payment-cancel-page"
        className="w-full max-w-md rounded-[2rem] border border-parchment/10 bg-nightcard p-10 text-center shadow-2xl"
      >
        <div className="mb-6 flex justify-center">
          <LogoMark dark size={52} />
        </div>
        <XCircle className="mx-auto h-12 w-12 text-clay" />
        <h1 className="mt-5 font-display text-3xl font-medium text-parchment">Compra cancelada</h1>
        <p className="mt-3 text-sm leading-relaxed text-parchment/65">
          Nenhum valor foi cobrado. Seus produtos continuam esperando por você no catálogo.
        </p>
        <Link
          to="/#catalogo"
          data-testid="payment-cancel-back"
          className="mt-7 inline-flex items-center gap-2 rounded-full bg-clay px-6 py-3.5 text-sm font-semibold text-parchment transition-colors hover:bg-ochre hover:text-forest"
        >
          <ArrowLeft className="h-4 w-4" />
          Voltar ao catálogo
        </Link>
      </div>
    </div>
  );
}
